import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["centered", "children", "correctFootprint", "disabled", "error", "hovered", "id", "inverseOnBackground", "neutral", "overflowEllipsisWidth", "rightAligned", "success", "UNSAFE_textProps", "warning", "white"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import useTextStyle from '@bubble-ui/hook-use-text-style';
import mapFeedbackState from '@bubble-ui/util-map-feedback-state';
import { ColorFunctions as Colors } from '@bubble-ui/particle-colors';
import { useDebugMode } from '@bubble-ui/provider-debug-mode';
import { isNative } from '@bubble-ui/util-platform';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import useStyleSheet from '@bubble-ui/hook-use-stylesheet';
import TextPrimitive from '@bubble-ui/primitive-text';
import usePropDeprecationWarning from '@bubble-ui/hook-use-prop-deprecation-warning';

var getMargin = function getMargin() {
  var correctFootprint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return correctFootprint ? {
    marginBottom: -10,
    marginTop: isNative ? -8 : -5
  } : {
    marginBottom: 0,
    marginTop: 0
  };
};

var TitleTertiary = function TitleTertiary(props) {
  var centered = props.centered,
      children = props.children,
      correctFootprint = props.correctFootprint,
      disabled = props.disabled,
      error = props.error,
      hovered = props.hovered,
      id = props.id,
      inverseOnBackground = props.inverseOnBackground,
      neutral = props.neutral,
      overflowEllipsisWidth = props.overflowEllipsisWidth,
      rightAligned = props.rightAligned,
      success = props.success,
      UNSAFE_textProps = props.UNSAFE_textProps,
      warning = props.warning,
      white = props.white,
      restProps = _objectWithoutProperties(props, _excluded);

  usePropDeprecationWarning({
    componentName: 'TitleTertiary',
    propName: 'hovered',
    shouldWarn: hovered !== undefined,
    removalDate: 'Q1 2022'
  });
  var designVersion = useDesignVersion();
  var styleOverride = useStyleSheet(TitleTertiary, undefined, _objectSpread({
    designVersion: designVersion
  }, props));
  var debugMode = useDebugMode();
  var numberOfLines = overflowEllipsisWidth ? 1 : 0;
  var textStyle = useTextStyle({
    textToken: 'text-style/text/labels/body/medium',
    colorTokenArgs: {
      interactiveState: disabled ? 'disabled' : hovered ? 'hovered' : 'default'
    },
    align: rightAligned && 'right' || centered && 'center' || 'left',
    numberOfLines: numberOfLines,
    colorToken: mapFeedbackState({
      neutral: neutral,
      warning: warning,
      error: error,
      success: success,
      'inverse-on-background': inverseOnBackground,
      inverse: white
    })
  });
  return /*#__PURE__*/React.createElement(TextPrimitive, _extends({}, UNSAFE_textProps, {
    id: id,
    tag: "h2",
    role: "heading",
    "aria-level": 2,
    numberOfLines: numberOfLines,
    style: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, textStyle), getMargin(correctFootprint)), {}, {
      paddingBottom: 3,
      paddingTop: 2
    }, overflowEllipsisWidth ? _objectSpread({
      maxWidth: overflowEllipsisWidth
    }, isNative ? {} : {
      whiteSpace: 'nowrap',
      display: undefined
    }) : {}), {}, {
      backgroundColor: debugMode ? Colors.__backgroundSubtleInline().toString() : undefined
    }, styleOverride.textStyle), styleOverride.viewStyle)
  }, restProps), children);
};

TitleTertiary.displayName = 'TitleTertiary';
var OverridableTitleTertiary = withProvisionalOverrideFromContext(TitleTertiary);
export default OverridableTitleTertiary;
//# sourceMappingURL=index.js.map